export default __webpack_public_path__ + "static/media/purple.e96081b1.svg";